<div class="spinner">
  <img src="/assets/dashboard/spinner.webp"/>
</div>
